import { Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { CircularProgress, Tooltip, Select, MenuItem, FormControl, InputAdornment, TextField, Button, TableContainer, Table, TableHead, TableBody, Paper, TablePagination, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Box, FormHelperText } from '@mui/material';
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { post } from '../../../src/services/http';
import { ContextSession } from "../../services/ContextSession";
import FilterListIcon from '@mui/icons-material/FilterList';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import IconButton from '@mui/material/IconButton';
import Popover from '@mui/material/Popover';
import CryptoJS from 'crypto-js';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useNavigate } from 'react-router-dom';

async function getSolicitudes() {
    const secretKey = "django-insecure-r*+fidc-a5yhm$*h7%2z5k&oly=!1=)3fyyv$tf-k9=qj%55mv";
    const query_string = "all_citas";

    // Generar la firma usando HMAC-SHA256
    const signature = CryptoJS.HmacSHA256(query_string, secretKey).toString();

    // Construir la URL con el query_string
    const url = `https://fevida.injupemp.gob.hn:8443/api/Citas/Consultar/Lista/`;
    //const url = `http://172.20.7.10:8083/api/Citas/Consultar/Lista/`;

    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'X-Signature': signature
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;

    } catch (error) {
        console.error("Error al obtener las solicitudes:", error);
        return null;
    }
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#19438C',
        color: 'white',
        fontSize: 16,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        borderRight: 'none', // Elimina la línea vertical entre columnas
        borderLeft: 'none', // Elimina la línea vertical entre columnas
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
    '&:hover': { // Agrega estilo al pasar el cursor sobre la fila
        backgroundColor: '#C1C1C1', // Cambia el color de fondo al pasar el cursor
    },
}));

function ListaCitasDomiciliarias() {
    let sessi = useContext(ContextSession);
    const [page, setPage] = useState(0);
    const [loading, setLoading] = useState(true);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [searchTerm, setSearchTerm] = useState('');
    const [loanType, setLoanType] = useState('');
    const [statusFilter, setStatusFilter] = useState('Solicitada');
    const [statusSolicitudFilter, setStatusSolicitudFilter] = useState('');
    const [filas, setFilas] = useState([]);
    const [searchDNI, setSearchDNI] = useState('');
    const handleSearchDNIChange = (event) => setSearchDNI(event.target.value);
    const navigate = useNavigate();

    useEffect(() => {
        async function fetchData() {
            try {
                let token = sessi.sessionData.token;
                const data = await getSolicitudes(token, sessi.ip);

                if (data) {
                    // Ordenar las filas
                    const sortedData = data.sort((a, b) => {
                        // Primero, ordenar por estado
                        if (a.asignado === null && b.asignado !== null) {
                            return -1; // 'Sin Asignar' debe ir antes que 'Asignado'
                        }
                        if (a.asignado !== null && b.asignado === null) {
                            return 1;
                        }
                        // Luego, ordenar por fecha de solicitud (más antigua primero)
                        return new Date(a.FechaSolicitud) - new Date(b.FechaSolicitud);
                    });
                    setFilas(sortedData);
                } else {
                    console.error('Error al obtener datos: datos no disponibles');
                }
            } catch (error) {
                console.error('Error al obtener datos:', error);
            } finally {
                setLoading(false);
            }
        }
        fetchData();
    }, [sessi.sessionData.token, sessi.ip]);


    const handleClick = (id) => {
        sessi.setVariable("VerCitaDomiciliaria", id);
        navigate('/Sociales/VerSolicitudCita');
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    // Reiniciar la página al cambiar el término de búsqueda
    const handleSearchChange = (event) => {
        const searchTerm = event.target.value;
        setSearchTerm(searchTerm);
        setPage(0); // Reinicia la página a la primera
    };

    const handleLoanTypeChange = (event) => {
        setLoanType(event.target.value);
    };

    const handleStatusChange = (event) => {
        setStatusFilter(event.target.value);
    };

    const handleStatusSolicitudChange = (event) => {
        setStatusSolicitudFilter(event.target.value);
    };

const filteredRows = filas
    .filter((row) => {
        const lowerCaseSearchTerm = searchTerm.toLowerCase();
        const lowerCaseSearchDNI = searchDNI.toLowerCase();

        const estadoCoincide = statusFilter === '' || row.estado === statusFilter;

        return (
            estadoCoincide &&
            (row.TipoPrestamo?.includes(loanType) || loanType === '') &&
            (searchTerm === '' || (
                row.nombre?.toLowerCase().includes(lowerCaseSearchTerm) ||
                row.DNI?.toLowerCase().includes(lowerCaseSearchTerm)
            )) &&
            (searchDNI === '' || row.DNI?.toLowerCase().includes(lowerCaseSearchDNI))
        );
    });



    const [anchorEl, setAnchorEl] = useState(null);
    const [filterType, setFilterType] = useState('');

    const handleFilterClick = (event, type) => {
        setAnchorEl(event.currentTarget);
        setFilterType(type);
    };

    const handleFilterClose = () => {
        setAnchorEl(null);
        setFilterType('');
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <div className="container" style={{ marginTop: 10 }}>
            {loading ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
                    <CircularProgress />
                </div>
            ) : (
                <>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 10 }}>
                        <h2><b>Lista de Solicitudes Visitas Domiciliarias Fe de Vida 2025</b></h2>
                    </div>

                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 2,
                        flexWrap: 'wrap',
                        mb: 2,
                        mt: 1,
                        justifyContent: 'center' // <--- Cambia aquí
                    }}>
                        <FormControl size="small" sx={{ minWidth: 170 }}>
                            <FormHelperText>Filtrar por Estado</FormHelperText>
                            <Select
                                value={statusFilter}
                                onChange={(e) => {
                                    setStatusFilter(e.target.value);
                                    setPage(0);
                                }}
                                displayEmpty
                                fullWidth
                            >
                                <MenuItem value="">Todos los Estados</MenuItem>
                                <MenuItem value="Solicitada">Solicitada</MenuItem>
                                <MenuItem value="Agendada">Agendada</MenuItem>
                                <MenuItem value="Finalizada">Finalizada</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>


                    <div className="row" style={{ marginTop: '20px' }}>
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead>
                                    <StyledTableRow>
                                        <StyledTableCell>#</StyledTableCell>
                                        <StyledTableCell>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <strong>DNI</strong>
                                                <Tooltip title="Buscar por DNI" arrow>
                                                    <IconButton onClick={(event) => handleFilterClick(event, 'searchDNI')}>
                                                        <ManageSearchIcon style={{ color: 'white' }} />
                                                    </IconButton>
                                                </Tooltip>
                                            </div>
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <strong>Nombre</strong>
                                                <Tooltip title="Buscar por Nombre" arrow>
                                                    <IconButton onClick={(event) => handleFilterClick(event, 'search')}>
                                                        <ManageSearchIcon style={{ color: 'white' }} />
                                                    </IconButton>
                                                </Tooltip>
                                            </div>
                                        </StyledTableCell>
                                        <StyledTableCell>Tipo Cita</StyledTableCell>
                                        <StyledTableCell>Dirección</StyledTableCell>
                                        {/*<StyledTableCell>Ubicación</StyledTableCell>*/}
                                        <StyledTableCell>Celular</StyledTableCell>
                                        <StyledTableCell>Referencia</StyledTableCell>
                                        <StyledTableCell>Tel. Referencia</StyledTableCell>
                                        <StyledTableCell>Fecha Solicitud</StyledTableCell>
                                        <StyledTableCell>Estado</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>Acciones</StyledTableCell>

                                    </StyledTableRow>
                                </TableHead>

                                <Popover
                                    id={id}
                                    open={open}
                                    anchorEl={anchorEl}
                                    onClose={handleFilterClose}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'center',
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'center',
                                    }}
                                >
                                    {filterType === 'search' && (
                                        <TextField
                                            placeholder="Buscar por Nombre"
                                            aria-label="Buscar por Nombre"
                                            value={searchTerm}
                                            onChange={handleSearchChange}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <SearchIcon />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    )}
                                    {filterType === 'searchDNI' && (
                                        <TextField
                                            placeholder="Buscar por DNI"
                                            aria-label="Buscar por DNI"
                                            value={searchDNI}
                                            onChange={handleSearchDNIChange}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <SearchIcon />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    )}

                                </Popover>
                                <TableBody>
                                    {filteredRows.length > 0 ? (
                                        (rowsPerPage > 0
                                            ? filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                            : filteredRows
                                        ).map((row, index) => (
                                            <StyledTableRow key={row.id}>
                                                {/*<StyledTableCell>{page * rowsPerPage + index + 1}</StyledTableCell>*/}
                                                <StyledTableCell>{row.id}</StyledTableCell>
                                                <StyledTableCell>{row.DNI}</StyledTableCell>
                                                <StyledTableCell>{row.nombre}</StyledTableCell>
                                                <StyledTableCell>{row.tipoCita}</StyledTableCell>
                                                <StyledTableCell>{row.direccion}</StyledTableCell>
                                                {/*<StyledTableCell>{row.ubicacion}</StyledTableCell>*/}
                                                <StyledTableCell>{row.celular}</StyledTableCell>
                                                <StyledTableCell>{row.nombreReferencia}</StyledTableCell>
                                                <StyledTableCell>{row.telefonoReferencia}</StyledTableCell>
                                                <StyledTableCell>{row.fechaRegistro ? row.fechaRegistro.slice(0, 16).replace('T', ' ') : 'Sin Fecha'}</StyledTableCell>
                                                <StyledTableCell >
                                                    <Box
                                                        sx={{
                                                            backgroundColor: row.estado === 'Agendada' ? 'green' : row.estado === 'Solicitada' ? 'yellow' : row.estado === 'Finalizada' ? 'red' : 'gray',
                                                            color: row.estado === 'Agendada' || row.estado === 'Finalizada' ? 'white' : 'black',
                                                            borderRadius: '8px',
                                                            px: 1,
                                                            py: 0.5,
                                                            display: 'inline-block',
                                                            fontWeight: 'bold',
                                                            fontSize: 18
                                                        }}
                                                    >
                                                        {row.estado}
                                                    </Box>
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    <Box display="flex" justifyContent="center">
                                                        <IconButton onClick={() => handleClick(row.id)}>
                                                            <VisibilityIcon sx={{ color: 'green' }} />
                                                        </IconButton>
                                                    </Box>
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        ))
                                    ) : (
                                        <StyledTableRow>
                                            <StyledTableCell colSpan={12} style={{ textAlign: 'center' }}>
                                                No se encontraron datos
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    )}
                                </TableBody>

                            </Table>
                        </TableContainer>
                        {filteredRows.length > 0 && (
                            // El componente de paginación ya usa `filteredRows.length` dinámicamente
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25]}
                                component="div"
                                count={filteredRows.length} // Longitud dinámica basada en la búsqueda
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                labelRowsPerPage={"Filas por página"}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        )}
                    </div>
                </>
            )}
        </div>
    );
}

export default ListaCitasDomiciliarias;